import { ApplicationState } from '../index';

import { NaicsCodeEntity } from '../../Models/Api/strongbox.financialportal';

/**
 * The full list of basic NAICS codes currently loaded in the store.
 */
export function GetIndustryNaicsCodes(state: ApplicationState): NaicsCodeEntity[] {
    return (state && state.industries) ? state.industries.naicsCodes : [];
}

/**
 * Whether the industries (basic NAICS codes) have been loaded at least once.
 */
export function IndustriesLoaded(state: ApplicationState): boolean {
    return (state && state.industries) ? state.industries.loaded : false;
}

/**
 * Whether a load of the industries (basic NAICS codes) is currently in flight.
 */
export function IndustriesLoading(state: ApplicationState): boolean {
    return (state && state.industries) ? state.industries.loading : false;
}
